import { createContext } from "react";

const context = createContext({ analytics: null })

export default context
